import React, { useState, useRef } from 'react';
import { ClipboardIcon, CheckIcon } from '@heroicons/react/24/outline';

interface CopyableBlockquoteProps {
  children: React.ReactNode;
}

export default function CopyableBlockquote({ children }: CopyableBlockquoteProps) {
  const [copied, setCopied] = useState(false);
  const contentRef = useRef<HTMLQuoteElement>(null);

  const handleCopy = async () => {
    // Extract text content from the blockquote
    const textContent = contentRef.current?.textContent || '';
    await navigator.clipboard.writeText(textContent);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  return (
    <div className="relative group my-4">
      {/* Copy button - appears on hover */}
      <button
        onClick={handleCopy}
        className="absolute top-2 right-2 p-1.5 rounded bg-surface-600/80 hover:bg-surface-500 text-surface-400 hover:text-surface-200 transition-all opacity-0 group-hover:opacity-100 z-10"
        title="Copy quote"
      >
        {copied ? (
          <CheckIcon className="w-4 h-4 text-green-400" />
        ) : (
          <ClipboardIcon className="w-4 h-4" />
        )}
      </button>

      {/* Blockquote content */}
      <blockquote
        ref={contentRef}
        className="border-l-4 border-primary-500 bg-surface-700/50 pl-4 pr-10 py-3 rounded-r-lg italic text-surface-300"
      >
        {children}
      </blockquote>
    </div>
  );
}
